import { render } from "./AppointmentPage.vue?vue&type=template&id=049eb88d&scoped=true"
import script from "./AppointmentPage.vue?vue&type=script&lang=js"
export * from "./AppointmentPage.vue?vue&type=script&lang=js"

import "./AppointmentPage.vue?vue&type=style&index=0&id=049eb88d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049eb88d"]])

export default __exports__